import i18n from "../../../../../i18n";
import { FOURTH_FLOOR_KZ_IMG } from "../../floor_images";
import elevator from "../../elevator_positions";

let fourth_floor_locations;
export default fourth_floor_locations = [
  {
    floor: i18n.t("fourth_floor"),
    imageURL: FOURTH_FLOOR_KZ_IMG,
    ...elevator.restaurant,
    title: "401",
    marked_position_x: 41,
    marked_position_y: 157,
  },
  {
    floor: i18n.t("fourth_floor"),
    imageURL: FOURTH_FLOOR_KZ_IMG,
    ...elevator.restaurant,
    title: "402",
    marked_position_x: 21,
    marked_position_y: 125,
  },
  {
    floor: i18n.t("fourth_floor"),
    imageURL: FOURTH_FLOOR_KZ_IMG,
    ...elevator.restaurant,
    title: "403",
    marked_position_x: 38,
    marked_position_y: 107,
  },
  {
    floor: i18n.t("fourth_floor"),
    imageURL: FOURTH_FLOOR_KZ_IMG,
    ...elevator.restaurant,
    title: "405",
    marked_position_x: 33,
    marked_position_y: 90,
  },
  {
    floor: i18n.t("fourth_floor"),
    imageURL: FOURTH_FLOOR_KZ_IMG,
    ...elevator.restaurant,
    title: "406",
    marked_position_x: 28,
    marked_position_y: 62,
  },
  {
    floor: i18n.t("fourth_floor"),
    imageURL: FOURTH_FLOOR_KZ_IMG,
    ...elevator.restaurant,
    title: "407",
    marked_position_x: 50,
    marked_position_y: 59,
  },
  {
    floor: i18n.t("fourth_floor"),
    imageURL: FOURTH_FLOOR_KZ_IMG,
    ...elevator.restaurant,
    title: "408",
    marked_position_x: 72,
    marked_position_y: 59,
  },
  {
    floor: i18n.t("fourth_floor"),
    imageURL: FOURTH_FLOOR_KZ_IMG,
    ...elevator.restaurant,
    title: "409",
    marked_position_x: 91,
    marked_position_y: 62,
  },
  {
    floor: i18n.t("fourth_floor"),
    imageURL: FOURTH_FLOOR_KZ_IMG,
    ...elevator.restaurant,
    title: "410",
    marked_position_x: 108,
    marked_position_y: 64,
  },
  {
    floor: i18n.t("fourth_floor"),
    imageURL: FOURTH_FLOOR_KZ_IMG,
    ...elevator.restaurant,
    title: "411",
    marked_position_x: 161,
    marked_position_y: 66,
  },
  {
    floor: i18n.t("fourth_floor"),
    imageURL: FOURTH_FLOOR_KZ_IMG,
    ...elevator.restaurant,
    title: "412",
    marked_position_x: 157,
    marked_position_y: 91,
  },
  {
    floor: i18n.t("fourth_floor"),
    imageURL: FOURTH_FLOOR_KZ_IMG,
    ...elevator.restaurant,
    title: "431",
    marked_position_x: 304,
    marked_position_y: 126,
  },
];
